import { useChoiceState } from '@context/ChoiceContext'
import { useConfig } from '@context/ConfigurationContext'
import useClinic from './useClinic'

export const useClinicAddress = (id?: string) => {
  const { clinicId } = useConfig()
  const { selectedBookableDateAndTime } = useChoiceState()
  const { data: clinic } = useClinic(id || selectedBookableDateAndTime?.clinicId || clinicId)

  if (!clinic) {
    return ''
  }

  const { street, houseNumber, zipCode, city } = clinic
  const clinicAddress = `${street} ${houseNumber}, ${zipCode} ${city}`
  return clinicAddress
}
